import { QUOTES } from "@/lib/constants";
import { DynamicGallery } from "./DynamicGallery";

export const Gallery = () => (
  <DynamicGallery
    section="gallery"
    id="gallery"
    testid="gallery"
    heading={
      <>
        Una community che <span className="italic text-lavender-deep">canta insieme.</span>
      </>
    }
    subtitle="Davanti al palco si mescolano generazioni che raramente condividono lo stesso spazio. Per la durata di un concerto, smettono di essere diverse tra loro."
    quote={QUOTES.crowd}
  />
);
